import { Pipe, inject, PipeTransform } from "@angular/core";
import { AsPipeBase } from "../bases/as-pipe-base";
import { AppDefinitions } from "../app-definitions.service";

@Pipe({
    name: "asInsurer",
    standalone: false
})
export class AsInsurerPipe extends AsPipeBase implements PipeTransform {
    constructor() {
        const _appDefinitions = inject(AppDefinitions);

        super(_appDefinitions, "insurer");
    }
}
